import React from "react";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Main from "./component/ui/Main";
// import { HashRouter as Router } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";

import LogIn from "./component/pages/userManage/LogIn";
import ScrollToTop from "./hook/ScrollToTop";
import { SearchProvider } from "./component/pages/contractDetail/hook/SearchContext";
const TOKEN = localStorage.getItem("TOKEN");

function App() {
  const token = TOKEN;

  if (!token) {
    return (
      <Router>
        <LogIn />
      </Router>
    );
  }
  return (
    <>
      <SearchProvider>
        <Router>
          <ScrollToTop />
          <Main />
        </Router>
      </SearchProvider>
    </>
  );
}

export default App;
